module.exports = __webpack_public_path__ + "img/1.2ff57419.png";